import React, { useEffect,useState } from "react";
import { ArchiveBoxIcon } from '@heroicons/react/24/outline';
import CustomTitle from '../sharedComponents/customTitle';
import CustomShoppngCardDetials from './customShoppingCardData';
import CustomShoppingCard from './customShoppingCrad';
import imageEroupa from '../../assets/images/shoppingOrouba.webp';
import imageFlag from '../../assets/images/oroba.webp';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BoxSection4 from "../../assets/images/BoxSection4.webp"
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const ShoppingEuropeSection =()=>{
    // const Navigate = useNavigate();
    const navigateWithLang = useLanguageNavigate();

    const {t} = useTranslation();
    const direction = useLanguageDirection();
     
    const handleClick =() => {
        navigateWithLang('/category-europe')
    }
    return(
        <div className='relative' dir={direction}>
          <img 
            src={BoxSection4} 
            alt="Background" 
            className="absolute right-0 hidden transform -translate-y-1/2 md:block top-1/2 w-14 md:w-20"
          />
            <div className="relative pt-5 pb-10 max-container">

            <CustomTitle
            title={t('shoppingEuropeSection.title')} 
            />
            <div className='px-4 mt-4 md:mt-5 md:flex md:px-0'>
            
            <CustomShoppingCard
            image={imageEroupa}
            title={t('shoppingEuropeSection.cardTitle2')}
            subTitle={t('shoppingEuropeSection.cardSubtitle2')} />
            <CustomShoppngCardDetials
              title={t('shoppingEuropeSection.cardTitle1')}
              image={imageFlag}
              onClick={handleClick}
              icon={ArchiveBoxIcon}
              imageTitle={t('shoppingEuropeSection.flagImageTitle')}
              children={t('shoppingEuropeSection.buttonLabel')}
              subTitle={t('shoppingEuropeSection.cardSubtitle1')} 
              area="67dfef98100f542a2c700c08" />
            </div>

            </div>
            
        </div>
    )
}

export default ShoppingEuropeSection;